import React from 'react';

import Article from './Article';
import MultiSortableTableHeader from "../components/MultiSortableTableHeader";

export const ItemList = (props) => {

    return (
            <table className="table table-striped">
                <thead>
                <tr id={"tableHeader"}>
                    <MultiSortableTableHeader
                            sortProperties={[{sortProperty: "erpIdno", sortPropertyName: "SAP-Nr"}]}
                            propertyToSortBy={props.propertyToSortBy}
                            sortDirection={props.sortDirection}
                            updateSortProperty={props.updateSortProperty}/>
                    <MultiSortableTableHeader
                            sortProperties={[{sortProperty: "gtin", sortPropertyName: "GTIN"}]}
                            propertyToSortBy={props.propertyToSortBy}
                            sortDirection={props.sortDirection}
                            updateSortProperty={props.updateSortProperty}/>
                    <MultiSortableTableHeader
                            sortProperties={[{sortProperty: "name", sortPropertyName: "Artikel-Bezeichnung"}]}
                            propertyToSortBy={props.propertyToSortBy}
                            sortDirection={props.sortDirection}
                            updateSortProperty={props.updateSortProperty}/>
                    <MultiSortableTableHeader
                            sortProperties={[{sortProperty: "vendorArticleNumber", sortPropertyName: "Hersteller-Artikelnummer"}]}
                            propertyToSortBy={props.propertyToSortBy}
                            sortDirection={props.sortDirection}
                            updateSortProperty={props.updateSortProperty}/>
                    <MultiSortableTableHeader
                            sortProperties={[{sortProperty: "brand", sortPropertyName: "Marke"}]}
                            propertyToSortBy={props.propertyToSortBy}
                            sortDirection={props.sortDirection}
                            updateSortProperty={props.updateSortProperty}/>
                    <th title={"grün: aktiv\nrot: inaktiv"}>Module</th>
                </tr>
                </thead>
                <tbody>
                {props.items.map((article) => {
                    return <Article {...article}
                                    key={article.id}
                                    updateErpIdno={props.updateErpIdno}
                                    updateGtin={props.updateGtin}
                                    updateName={props.updateName}
                                    updateVendorArticleNumber={props.updateVendorArticleNumber}/>;
                })}
                </tbody>
            </table>
    )
};

export default ItemList;


// WEBPACK FOOTER //
// ./src/admin/article/ItemList.js